<template>
  <div class="container">
    <label for="dataTable" class=" iot-station d-flex justify-content-start">Device Graph</label>
    <div class="form-check form-check-inline">
      <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value=1
        checked v-model="selectedMoistureOption" @change="handleselectedMoistureOption()">
      <label class="form-check-label custom-label" for="inlineRadio1">Flow</label>
    </div>
    <!-- <div class="form-check form-check-inline py-0">
      <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value=0
        v-model="selectedMoistureOption" @change="handleselectedMoistureOption()">
      <label class="form-check-label custom-label" for="inlineRadio1">Moisture Adj. Flow</label>
    </div> -->
    <div class="current-flowrate-container mb-4">
      <div
        class="form-check form-check-inline device-current-flowrate d-flex  justify-content-center align-items-center">
        <label class="custom-label">Current Value&nbsp;:&nbsp;<span>{{ this.currentFlowRate }}</span></label>
      </div>
    </div>
    <div class="button-container d-flex justify-content-center px-5">
      <label for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1">Hub:
      </label>
      <div class="form-group me-2">
        <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
          id="autoSizingSelect" v-model="selectedHub" @change="handleDropdownChange('hub')">
          <option value="" disabled>Select Option</option>
          <option v-for="hub in hubs" :key="hub.uuid" :value="hub.uuid">{{ hub.name }}</option>
        </select>
      </div>
      <label for="time-range-select"
        class="custom-label d-flex  justify-content-center  align-items-center me-1">Controller: </label>
      <div class="form-group me-2">
        <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
          id="autoSizingSelect" v-model="selectedController" @change="handleDropdownChange('controller')">
          <option value="" disabled>Select Option</option>
          <option v-for="comp in components" :key="comp.uuid" :value="comp.uuid">{{ comp.name }}</option>
        </select>
      </div>
      <label for="time-range-select"
        class="custom-label d-flex  justify-content-center  align-items-center me-1">Device: </label>
      <div :class="{ 'form-group': true, 'me-2': selectedMoistureOption === 0, 'me-4': selectedMoistureOption === 1 }">
        <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
          id="autoSizingSelect" v-model="selectedDevice" @change="handleDropdownChange('device')">
          <option value="" disabled>Select Option</option>
          <option v-for="device in devices" :key="device.uuid" :value="device.uuid">{{ device.name }}</option>
        </select>
      </div>
      <label for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1"
        v-if="selectedMoistureOption === 0">Moisture: </label>
      <div class="form-group me-4" v-if="selectedMoistureOption === 0">
        <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
          id="autoSizingSelect" v-model="selectedMoisture" @change="handleDropdownChange('moisture')">
          <option v-for="Moisture in Moistures" :key="Moisture.name" :value="parseFloat(Moisture.name).toFixed(1)">{{
            parseFloat(Moisture.name).toFixed(1) }}</option>
        </select>
      </div>
      <div class="form-group" v-if="!isDateRangeChecked">
        <button type="submit" class="btn btn-sm device-graph-button me-2 "
          :class="{ 'active': selectedTimeframe === '1D' }" @click="handle1DClick">1D</button>
      </div>
      <div class="form-group" v-if="!isDateRangeChecked">
        <button type="submit" class="btn btn-sm device-graph-button me-4"
          :class="{ 'active': selectedTimeframe === '1M' }" @click="handle1MClick">1M</button>
      </div>

      <!-- <div class="form-group" v-if="!isDateRangeChecked">
        <button type="submit" class="btn btn-sm device-graph-button me-4"
          :class="{ 'active': selectedTimeframe === '1Y' }" @click="handle1YClick">1Y</button>
      </div> -->
      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input shadow-none" id="exampleCheck1" v-model="isDateRangeChecked"
          @change="handleDateRangeChange">
        <label class="form-check-label custom-label" for="exampleCheck1">Date Range</label>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center mt-4 ">

     <div class="form-group form-check " v-if="isDateRangeChecked">
        <input type="checkbox" class="form-check-input shadow-none me-2" id="exampleCheck1" v-model="isDayGraphChecked"
          @change="handleDayGraphChange">
        <label class="form-check-label custom-label me-3" for="exampleCheck1">Day Graph</label>
      </div>

       <div class="d-flex justify-content-center align-items-center" v-if="isDayGraphChecked && isDateRangeChecked">
        <label for="start-date" class="custom-label me-1">Select Date:</label>
        <div class="form-group me-3">
          <input id="start-date" type="date" class="form-control shadow-none form-select-sm custom-input"
            v-model="startdate"  @change="validateDate">
        </div>
      </div> 
      
      <div class="d-flex justify-content-center align-items-center" v-if="isDateRangeChecked && !isDayGraphChecked">
        <label for="start-date" class="custom-label me-1">Start Date:</label>
        <div class="form-group me-3">
          <input id="start-date" type="date" class="form-control shadow-none form-select-sm custom-input"
            v-model="startdate">
        </div>
      </div>

      <label v-if="isDateRangeChecked && !isDayGraphChecked" for="time-range-select"
        class="custom-label d-flex  justify-content-center  align-items-center me-1">Month:
      </label>
      <div class="form-group me-3" v-if="isDateRangeChecked && !isDayGraphChecked">
        <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
          id="autoSizingSelect" v-model="daterange">
          <option v-for="month in monthOptions" :key="month" :value="month">{{ month }}</option>
        </select>
      </div>
      <!-- <div class="d-flex justify-content-center align-items-center" v-if="isDateRangeChecked">
          <label for="start-date" class="custom-label me-1">End Date:</label>
          <div class="form-group me-3">
            <input id="end-date" type="date" class="form-control shadow-none form-select-sm custom-input"
            v-model="enddate" :min="startdate" :max="endDateMax" @change="updateEndDateMax">

          </div>

        </div> -->

      <button type="submit" class="btn btn-primary btn-sm generate-button generate-button-pos me-2 "
        v-if="isDateRangeChecked" @click="handleDateClick" :disabled="!selectedDevice || !startdate">Submit</button>

    </div>
    <small v-if="errorMessage && isDateRangeChecked && isDayGraphChecked" class="text-danger" style="font-size: 12px;">{{ errorMessage }}</small>
    <!-- <small v-if="isDateInvalid" class="text-danger" style="font-size: 12px;">
  The gap between the start and end date cannot be more than 30 days.
</small> -->


    <div class="device-graph">
      <div v-if="loading" class="loading-indicator spinner-border spinner-border"></div>
      <div class="no-record-device-graph">{{ noRecordFound }}</div>
      <apexchart  type="line" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>

  </div>
</template>
<script>

import { ddReportComponent, ddReportHub } from '@/http/dashboard/report.http';
import { ddDeviceGraph, getDeviceGraphData } from '@/http/dashboard/iot-insight.http'

export default {
  name: 'IotGraph',
  components: {
  },
  data() {
    return {
      // zoomStart: null,
      // zoomEnd: null,
      loading: false,
      isTimer: 0,
      noRecordFound: '',
      selectedTimeframe: "1D",
      currentFlowRate: "",
      selectedHub: '',
      selectedDevice: '',
      selectedController: '',
      selectedMoisture: 0.5,
      isDateRangeChecked: 0,
      isDayGraphChecked: 0,
      startdate: '',
      minDate: '',
      maxDate: '',
      errorMessage: '',
      // enddate: '',     
      // endDateMax: '', 
      // isEndDateInvalid: false,
      // isDateInvalid: false,
      apiResponse: null, // Initialize apiResponse as null
      monthOptions: ['1M'],
      daterange: '1M',
      series: [{
        name: "Data",
        data: [] // Initially empty, will be populated with data for each timestamp
      }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          animations: {
            enabled: false,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: false,
              delay: 150
            },
            dynamicAnimation: {
              enabled: false,
              speed: 350
            }
          },
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false // Disables the toolbar
          },
        },

        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        grid: {
          row: {
            colors: ['#FFFFFF', 'transparent'],
            opacity: 0.5
          },
        },
        xaxis: {
          type: 'category',
          categories: [],
          // tickAmount: 400,
          labels: {
            rotateAlways: true,
            rotate: -45,
            formatter: undefined
          },
          offsetY: 5,

          tooltip: {
            enabled: false // Disable tooltip for x-axis
          } // Will be populated with timestamps
        }
      },
      selectedMoistureOption: 1,
      sData: {},
      hubs: [],
      components: [],
      devices: [],
      Moistures: [
        { name: 0.5 },
        { name: 1.0 },
        { name: 1.5 },
        { name: 2.0 },
        { name: 2.5 },
        { name: 3.0 }
      ],

      graphMap : {}
    }
  },
  async mounted() {
    await this.getddReportHub()
    this.fetchGraphData(this.selectedTimeframe);
    // Set up a timer to refresh the graph every 15 seconds
    this.timer = setInterval(() => {
      this.isTimer = 1
      this.fetchGraphData(this.selectedTimeframe);
    }, 10000);

     const today = new Date();
    const max = today.toISOString().split('T')[0];

    const twoMonthsBack = new Date(today);
    twoMonthsBack.setMonth(today.getMonth() - 2);
    twoMonthsBack.setDate(1);
    const min = twoMonthsBack.toISOString().split('T')[0];

    this.minDate = min;
    this.maxDate = max;
  
  },
  beforeUnmount() {
    // Clear the timer when the component is destroyed to prevent memory leaks
    clearInterval(this.timer);
  },


  methods: {

    async getddReportHub() {
      try {
        const data = await ddReportHub();
      this.hubs = data || [];

      // Select the first hub by default if available
      this.selectedHub = this.hubs.length > 0 ? this.hubs[0].uuid : '';

      if (this.selectedHub) {
        await this.getddReportComponent();
      }
      } catch (error) {
        this.error = error.message; // Set the error message
        console.error('Error fetching report hubs:', error);
      }


    },
    async getddReportComponent() {
      try {
        // Check if the selected hub is different from the previous one
        if (this.selectedHub !== this.previousHub) {
          this.previousHub = this.selectedHub; // Update the previous hub

       const data = await ddReportComponent({ id: this.selectedHub });
      this.components = data || [];

      // Select the first controller by default if available
      this.selectedController = this.components.length > 0 ? this.components[0].uuid : '';

      if (this.selectedController) {
        await this.getddReportDevices();
      }
        }
      } catch (error) {
        this.error = error.message; // Set the error message
        console.error('Error fetching Component:', error);
      }
    },
    async getddReportDevices() {
      try {

        let data = [];
        data = await ddDeviceGraph({ id: this.selectedController });
        const response = await data;

        if (!response || response.length === 0) {
          this.devices = [];
          this.selectedDevice = ''; // or set to a default value if you prefer
        } else {
          if (!response.find(device => device.uuid === this.selectedDevice)) {
            this.selectedDevice = ''; // Set to the first device if selected device is not found
            this.series[0].data = [];
            this.noRecordFound = "";
            this.currentFlowRate = "";
          }
          this.devices = response;
        }
      } catch (error) {
        this.error = error.message; // Set the error message
        console.error('Error fetching device:', error);
      }
    },

    async fetchGraphData(timeframe) {
      try {
        if (this.selectedHub && this.selectedController && this.selectedDevice) {
          if (this.isTimer == 0) {
            this.loading = true;
            this.series[0].data = [];
            this.currentFlowRate = ""
          }

          const payload = {
            timeframe: timeframe,
            hub: this.selectedHub,
            controller: this.selectedController,
            device: this.selectedDevice,
          };

          // Include or exclude "moisture" parameter based on the selected option
          if (this.selectedMoistureOption === 0) {
            payload.moisture = parseFloat(this.selectedMoisture);
          }

          if (this.selectedTimeframe === "" && this.isDateRangeChecked) {
            payload.startdate = this.startdate;
              if (this.isDayGraphChecked) {
               payload.daterange = "1D";
               } else if(!this.isDayGraphChecked) {
               payload.daterange = this.daterange;
               }
            // payload.enddate = this.enddate
          }
          // const hours = [];
          const monthRange = [];
          const monthYearArray = [];
          // const srData = [];
          const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const seriesData = [];
          const xaxisCategories = [];
          // let started = false;

          if (timeframe == '1D') {

            let chour = new Date().toLocaleTimeString('en-US', {
              hour: '2-digit',
              hour12: true,
              timeZone: 'Asia/Kolkata'
            });
            // const cdate = new Date().toLocaleDateString();
            const timeArray = ['01 AM', '02 AM', '03 AM', '04 AM', '05 AM', '06 AM', '07 AM', '08 AM', '09 AM', '10 AM', '11 AM', '12 PM', '01 PM', '02 PM', '03 PM', '04 PM', '05 PM', '06 PM', '07 PM', '08 PM', '09 PM', '10 PM', '11 PM', '12 AM'];
            // let indexstart;
            let firstPart = []
            let secondPart = []
            const startIndex = timeArray.indexOf(chour);
            if (startIndex == 23) {
              firstPart = timeArray.slice(0);
              secondPart = timeArray.slice(0, 1);
            } else {
              firstPart = timeArray.slice(startIndex + 1);
              secondPart = timeArray.slice(0, startIndex + 2);
            }

            const rArray = firstPart.concat(secondPart);

            rArray[rArray.length - 1] = rArray[rArray.length - 1] + " "

            const response = await getDeviceGraphData(payload);
            this.currentFlowRate = response.flowrate
            if (!response || !response.data || response.data.length === 0) {
              this.noRecordFound = "No Record Found";
            } else if (response || response.data || response.data.length > 0) {
              this.noRecordFound = '';
            }

            const currentDate = new Date();
 
            const dateStr = new Date().toLocaleDateString('en-CA', {
  timeZone: 'Asia/Kolkata',
});


            this.graphMap = {}

            if (response.data != null) {

            response.data.forEach(item => {
              let date = new Date(item.timestamp);
              let dayKey = date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                hour12: true,
                timeZone: 'UTC'  // Force UTC time zone to avoid local time zone issues
              });

              if (item.timestamp.includes(dateStr) || chour != dayKey) {

                if (!this.graphMap[dayKey]) {
                this.graphMap[dayKey] = { values: [], labels: [] };
                }
                this.graphMap[dayKey].values.push(item.value);
                this.graphMap[dayKey].labels.push(item.flag);
        
              }
            });
          }
            const arr1 = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

           rArray.forEach((element, indexx) => {
              if (this.graphMap[element]) {
                const dataList = this.graphMap[element];

              const result = arr1.map(val => {
              const index = dataList.labels.indexOf(val);
              return index !== -1 ? dataList.values[index] : null;
              });

              seriesData.push(...result);
              xaxisCategories.push(element,'','','','','','','','','','','');
              } else {
                if (indexx === rArray.length - 1) {
                  seriesData.push(null);
                  xaxisCategories.push(element);
                } else {
                  seriesData.push(null,null,null,null,null,null,null,null,null,null,null,null);
                  xaxisCategories.push(element,'','','','','','','','','','','');
                }
                
              }
            });

            // const chart = this.$refs.deviceChart?.chart;
            // if (chart && chart.w.globals?.minX !== undefined && chart.w.globals?.maxX !== undefined) {
            //   this.zoomStart = chart.w.globals.minX;
            //   this.zoomEnd = chart.w.globals.maxX;
            // }

            this.series[0].data = seriesData;
            const updatedOptions = { ...this.chartOptions };
            updatedOptions.xaxis.categories = xaxisCategories;
            this.chartOptions = updatedOptions;
            
          //   this.$nextTick(() => {
          //   const chart = this.$refs.deviceChart?.chart;
          //   if (chart && this.zoomStart !== null && this.zoomEnd !== null) {
          //     chart.zoomX(this.zoomStart, this.zoomEnd);
          //   }
          // });

            
          } else if (timeframe == "1M") {

          const monthRange = [];

          const today = new Date();
          const startDate = new Date();
          startDate.setDate(today.getDate() - 30); // last 30 days including today

          for (
            let d = new Date(startDate);
            d <= today;
            d.setDate(d.getDate() + 1)
          ) {
            monthRange.push(`${monthNames[d.getMonth()]} ${d.getDate()}`);
          }

            // const currentDate = new Date();
            // const currentMonth = currentDate.getMonth();
            // const currentYear = currentDate.getFullYear();
            // const currentDayOfMonth = currentDate.getDate();

            // const sameDayOfPrevMonth = new Date(currentYear, currentMonth - 1, currentDayOfMonth + 1);

            // for (let year = sameDayOfPrevMonth.getFullYear(), month = sameDayOfPrevMonth.getMonth(); year <= currentYear && month <= currentMonth; month++) {
            //   const startDay = (year === sameDayOfPrevMonth.getFullYear() && month === sameDayOfPrevMonth.getMonth()) ? sameDayOfPrevMonth.getDate() : 1;
            //   const endDay = (year === currentYear && month === currentMonth) ? currentDayOfMonth : new Date(year, month + 1, 0).getDate();
            //   for (let day = startDay; day <= endDay; day++) {
            //     // Format the date as "day month"
            //     const formattedDate = `${monthNames[month]} ${day}`;
            //     monthRange.push(formattedDate);
            //   }
            // }

            // let date;
            const response = await getDeviceGraphData(payload);
            this.currentFlowRate = response.flowrate;
            if (!response || !response.data || response.data.length === 0) {
              this.noRecordFound = "No Record Found";
            } else if (response || response.data || response.data.length > 0) {
              this.noRecordFound = '';
            }

            let monthDataMap = {};

           
     if (response.data != null) {
            response.data.forEach(item => {

              let date = new Date(item.timestamp);
              const utcDate = new Date(date.toISOString()); // normalize to UTC
              // let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
              const monthKey = `${monthNames[utcDate.getUTCMonth()]} ${utcDate.getUTCDate()}`;
              if (!monthDataMap[monthKey]) {

                 monthDataMap[monthKey] = { values: [], labels: [] };
              }
              monthDataMap[monthKey].values.push(item.value);
              // monthDataMap[monthKey].labels.push(item.flag);
              monthDataMap[monthKey].labels.push(Number(item.flag));
            });
          }
            const monthArr = [0, 3, 6, 9, 12, 15, 18, 21];

            monthRange.forEach((element, indexx) => {
              if (monthDataMap[element]) {
                const dataList = monthDataMap[element];

                const result = monthArr.map(val => {
                const index = dataList.labels.indexOf(val);
                return index !== -1 ? dataList.values[index] : null;
                });

                seriesData.push(...result);
                xaxisCategories.push(element,'','','','','','','');
              } else {
                if (indexx === monthRange.length - 1) {
                  seriesData.push(null);
                  xaxisCategories.push(element);
                } else {
                  seriesData.push(null,null,null,null,null,null,null,null);
                  xaxisCategories.push(element,'','','','','','','');
                }
                
              }
            });

            // Capture zoom range before updating
            // const chart = this.$refs.deviceChart?.chart;
            // if (chart && chart.w.globals?.minX !== undefined && chart.w.globals?.maxX !== undefined) {
            //   this.zoomStart = chart.w.globals.minX;
            //   this.zoomEnd = chart.w.globals.maxX;
            // }

            this.series[0].data = seriesData;
            const updatedOptions = { ...this.chartOptions };
            updatedOptions.xaxis.categories = xaxisCategories;
            this.chartOptions = updatedOptions;

            // Restore zoom after DOM update
          //   this.$nextTick(() => {
          //   const chart = this.$refs.deviceChart?.chart;
          //   if (chart && this.zoomStart !== null && this.zoomEnd !== null) {
          //     chart.zoomX(this.zoomStart, this.zoomEnd);
          //   }
          // });

          } else if (timeframe == "1Y") {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth();


            const year = currentDate.getFullYear().toString().slice(-2);

            const response = await getDeviceGraphData(payload);
            this.currentFlowRate = response.flowrate;
            if (!response || !response.data || response.data.length === 0) {
              this.noRecordFound = "No Record Found";
            } else if (response || response.data || response.data.length > 0) {
              this.noRecordFound = '';
            }


            for (let i = currentMonth; i >= 0; i--) {
              monthYearArray.push(`${monthNames[i]} ${year}`);
            }
            for (let i = 11; i > currentMonth; i--) {
              monthYearArray.push(`${monthNames[i]} ${year - 1}`);
            }
            monthYearArray.reverse()

            let yearDataMap = {};

            response.data.forEach(item => {

              let date = new Date(item.timestamp);
              let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${year}`;
              if (!yearDataMap[monthKey]) {
                yearDataMap[monthKey] = {
                  seriesData: [item.start, item.low, item.high, item.end],
                  xaxisCategories: [monthKey, '', '', '']
                };
              }
            });

            monthYearArray.forEach(element => {
              if (yearDataMap[element]) {
                seriesData.push(...yearDataMap[element].seriesData);
                xaxisCategories.push(...yearDataMap[element].xaxisCategories);
              } else {
                // Handle case where no data exists for the month
                seriesData.push(null, null, null, null);
                xaxisCategories.push(element, '', '', '');
              }
            });

            this.series[0].data = seriesData;
            const updatedOptions = { ...this.chartOptions };
            updatedOptions.xaxis.categories = xaxisCategories;
            this.chartOptions = updatedOptions;
          } else if (timeframe == "") {
            if (this.daterange == "1M" && !this.isDayGraphChecked) {
              const currentDate = new Date(this.startdate);  // Current date
              const currentMonth = currentDate.getMonth();  // Current month (0-indexed)
              const currentYear = currentDate.getFullYear();  // Current year
              const currentDayOfMonth = currentDate.getDate();  // Current day of the month

              // Set the end date to be 30 days ahead from the current date
              const nextMonthDate = new Date(currentDate);
              nextMonthDate.setDate(currentDate.getDate() + 30);  // Adds 30 days

              let monthRange = [];

              // Loop over each day from current date to the next 30 days
              for (let date = new Date(currentYear, currentMonth, currentDayOfMonth);
                date <= nextMonthDate;
                date.setDate(date.getDate() + 1)) {

                const formattedDate = `${monthNames[date.getMonth()]} ${date.getDate()}`;
                monthRange.push(formattedDate);  // Add formatted date to the range
              }

              // Fetch data
              const response = await getDeviceGraphData(payload);
              this.currentFlowRate = response.flowrate;
              if (!response || !response.data || response.data.length === 0) {
                this.noRecordFound = "No Record Found";
              } else if (response || response.data || response.data.length > 0) {
                this.noRecordFound = '';
              }

              let seriesData = [];
              let xaxisCategories = [];

              let monthDataMap = {};

              if (response.data != null) {

              // Process the data into the monthDataMap
              response.data.forEach(item => {
                let date = new Date(item.timestamp);
                let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
                 if (!monthDataMap[monthKey]) {

                 monthDataMap[monthKey] = { values: [], labels: [] };
              }
              monthDataMap[monthKey].values.push(item.value);
              monthDataMap[monthKey].labels.push(item.flag);
              });
            }
               const monthArr = [0, 3, 6, 9, 12, 15, 18, 21];

            monthRange.forEach((element, indexx) => {
              if (monthDataMap[element]) {
                const dataList = monthDataMap[element];

                const result = monthArr.map(val => {
                const index = dataList.labels.indexOf(val);
                return index !== -1 ? dataList.values[index] : null;
                });

                seriesData.push(...result);
                xaxisCategories.push(element,'','','','','','','');
              } else {
                if (indexx === monthRange.length - 1) {
                  seriesData.push(null);
                  xaxisCategories.push(element);
                } else {
                  seriesData.push(null,null,null,null,null,null,null,null);
                  xaxisCategories.push(element,'','','','','','','');
                }
                
              }
            });

              this.series[0].data = seriesData;  // Assign the processed data to the chart
              const updatedOptions = { ...this.chartOptions };
              updatedOptions.xaxis.categories = xaxisCategories;  // Update xaxis categories
              this.chartOptions = updatedOptions;  // Apply the updated chart options
            } else if (this.daterange == "3M" && !this.isDayGraphChecked) {
              // const currentDate = new Date(this.startdate);  // Current date
              // currentDate.setDate(currentDate.getDate() + 2);
              // const currentMonth = currentDate.getMonth();  // Current month (0-indexed)
              // const currentYear = currentDate.getFullYear();  // Current year
              // const currentDayOfMonth = currentDate.getDate();  // Current day of the month

              // Set the end date to be 30 days ahead from the current date
              // const nextMonthDate = new Date(currentDate);
              // nextMonthDate.setDate(currentDate.getDate() + 90);  // Adds 30 days

              // let monthRange = [];

              // Loop over each day from current date to the next 30 days
              // for (let date = new Date(currentYear, currentMonth, currentDayOfMonth); 
              //     date <= nextMonthDate; 
              //     date.setDate(date.getDate() + 3)) {

              //     const formattedDate = `${monthNames[date.getMonth()]} ${date.getDate()}`;
              //     monthRange.push(formattedDate);  // Add formatted date to the range
              // }

              // Fetch data
              const response = await getDeviceGraphData(payload);
              this.currentFlowRate = response.flowrate;
              if (!response || !response.data || response.data.length === 0) {
                this.noRecordFound = "No Record Found";
              } else if (response || response.data || response.data.length > 0) {
                this.noRecordFound = '';
              }

              let seriesData = [];
              let xaxisCategories = [];

              // let monthDataMap = {};

              // Process the data into the monthDataMap
              // response.data.forEach(item => {
              //     let date = new Date(item.timestamp);
              //     let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
              //     if (!monthDataMap[monthKey]) {
              //         monthDataMap[monthKey] = {
              //             seriesData: [item.start, item.low, item.high, item.end],
              //             xaxisCategories: [monthKey, '', '', '']
              //         };
              //     }
              // });

              // Populate the series data and xaxis categories based on month range
              // monthRange.forEach(element => {
              //     if (monthDataMap[element]) {
              //         seriesData.push(...monthDataMap[element].seriesData);
              //         xaxisCategories.push(...monthDataMap[element].xaxisCategories);
              //     } else {
              //         // Handle case where no data exists for the specific day
              //         seriesData.push(null, null, null, null);
              //         xaxisCategories.push(element, '', '', '');
              //     }
              // });

              response.data.forEach(item => {
                let date = new Date(item.timestamp);
                let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
                if (item.sensorid === "") {
                  // Set start, low, high, and end values to null if sensorid is empty
                  seriesData.push(null, null, null, null);
                } else {
                  // Otherwise, use the actual values
                  seriesData.push(item.start, item.low, item.high, item.end);
                }
                xaxisCategories.push(monthKey, '', '', '');
              });

              this.series[0].data = seriesData;  // Assign the processed data to the chart
              const updatedOptions = { ...this.chartOptions };
              updatedOptions.xaxis.categories = xaxisCategories;  // Update xaxis categories
              this.chartOptions = updatedOptions;  // Apply the updated chart options
            } else if (this.daterange == "6M" && !this.isDayGraphChecked) {
              // const currentDate = new Date(this.startdate);  // Current date
              // currentDate.setDate(currentDate.getDate() + 5);
              // const currentMonth = currentDate.getMonth();  // Current month (0-indexed)
              // const currentYear = currentDate.getFullYear();  // Current year
              // const currentDayOfMonth = currentDate.getDate();  // Current day of the month

              // // Set the end date to be 30 days ahead from the current date
              // const nextMonthDate = new Date(currentDate);
              // nextMonthDate.setDate(currentDate.getDate() + 180);  // Adds 30 days

              // let monthRange = [];

              // Loop over each day from current date to the next 30 days
              // for (let date = new Date(currentYear, currentMonth, currentDayOfMonth); 
              //     date <= nextMonthDate; 
              //     date.setDate(date.getDate() + 6)) {

              //     const formattedDate = `${monthNames[date.getMonth()]} ${date.getDate()}`;
              //     monthRange.push(formattedDate);  // Add formatted date to the range
              // }

              // Fetch data
              const response = await getDeviceGraphData(payload);
              this.currentFlowRate = response.flowrate;
              if (!response || !response.data || response.data.length === 0) {
                this.noRecordFound = "No Record Found";
              } else if (response || response.data || response.data.length > 0) {
                this.noRecordFound = '';
              }

              let seriesData = [];
              let xaxisCategories = [];

              // let monthDataMap = {};

              // Process the data into the monthDataMap
              // response.data.forEach(item => {
              //     let date = new Date(item.timestamp);
              //     let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
              //     if (!monthDataMap[monthKey]) {
              //         monthDataMap[monthKey] = {
              //             seriesData: [item.start, item.low, item.high, item.end],
              //             xaxisCategories: [monthKey, '', '', '']
              //         };
              //     }
              // });

              // Populate the series data and xaxis categories based on month range
              // monthRange.forEach(element => {
              //     if (monthDataMap[element]) {
              //         seriesData.push(...monthDataMap[element].seriesData);
              //         xaxisCategories.push(...monthDataMap[element].xaxisCategories);
              //     } else {
              //         // Handle case where no data exists for the specific day
              //         seriesData.push(null, null, null, null);
              //         xaxisCategories.push(element, '', '', '');
              //     }
              // });

              response.data.forEach(item => {
                let date = new Date(item.timestamp);
                let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
                if (item.sensorid === "") {
                  // Set start, low, high, and end values to null if sensorid is empty
                  seriesData.push(null, null, null, null);
                } else {
                  // Otherwise, use the actual values
                  seriesData.push(item.start, item.low, item.high, item.end);
                }
                xaxisCategories.push(monthKey, '', '', '');
              });

              this.series[0].data = seriesData;  // Assign the processed data to the chart
              const updatedOptions = { ...this.chartOptions };
              updatedOptions.xaxis.categories = xaxisCategories;  // Update xaxis categories
              this.chartOptions = updatedOptions;  // Apply the updated chart options
            } else if (this.isDayGraphChecked) {
              
            // let chour = new Date().toLocaleTimeString('en-US', {
            //   hour: '2-digit',
            //   hour12: true,
            //   timeZone: 'Asia/Kolkata'
            // });
            // const cdate = new Date().toLocaleDateString();
            // const timeArray = ['01 AM', '02 AM', '03 AM', '04 AM', '05 AM', '06 AM', '07 AM', '08 AM', '09 AM', '10 AM', '11 AM', '12 PM', '01 PM', '02 PM', '03 PM', '04 PM', '05 PM', '06 PM', '07 PM', '08 PM', '09 PM', '10 PM', '11 PM', '12 AM'];
            // let indexstart;
            // let firstPart = []
            // let secondPart = []
            // const startIndex = timeArray.indexOf(chour);
            // if (startIndex == 23) {
            //   firstPart = timeArray.slice(0);
            //   secondPart = timeArray.slice(0, 1);
            // } else {
            //   firstPart = timeArray.slice(startIndex + 1);
            //   secondPart = timeArray.slice(0, startIndex + 2);
            // }

            // const rArray = firstPart.concat(secondPart);
            
            const rArray = [
            '12 AM', '01 AM', '02 AM', '03 AM', '04 AM', '05 AM',
            '06 AM', '07 AM', '08 AM', '09 AM', '10 AM', '11 AM',
            '12 PM', '01 PM', '02 PM', '03 PM', '04 PM', '05 PM',
            '06 PM', '07 PM', '08 PM', '09 PM', '10 PM', '11 PM',
            '12 AM' 
          ];

            rArray[rArray.length - 1] = rArray[rArray.length - 1] + " "

            const response = await getDeviceGraphData(payload);
            this.currentFlowRate = response.flowrate
            if (!response || !response.data || response.data.length === 0) {
              this.noRecordFound = "No Record Found";
            } else if (response || response.data || response.data.length > 0) {
              this.noRecordFound = '';
            }

            this.graphMap = {};
            if (response.data != null) {
            response.data.forEach(item => {

              let date = new Date(item.timestamp);
              let dayKey = date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                hour12: true,
                timeZone: 'UTC'  // Force UTC time zone to avoid local time zone issues
              });
              

              if (!this.graphMap[dayKey]) {
              this.graphMap[dayKey] = { values: [], labels: [] };
              }
              this.graphMap[dayKey].values.push(item.value);
              this.graphMap[dayKey].labels.push(item.flag);
            });
          }
            const arr1 = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

           rArray.forEach((element, indexx) => {
              if (this.graphMap[element]) {
                const dataList = this.graphMap[element];

                let datapoint = 0

              const result = arr1.map(val => {
              const index = dataList.labels.indexOf(val);
              return index !== -1 ? dataList.values[index] : null;
              });

              seriesData.push(...result);
              xaxisCategories.push(element,'','','','','','','','','','','');
              } else {
                if (indexx === rArray.length - 1) {
                  seriesData.push(null);
                  xaxisCategories.push(element);
                } else {
                  seriesData.push(null,null,null,null,null,null,null,null,null,null,null,null);
                  xaxisCategories.push(element,'','','','','','','','','','','');
                }
                
              }
            });


            this.series[0].data = seriesData;
            const updatedOptions = { ...this.chartOptions };
            updatedOptions.xaxis.categories = xaxisCategories;
            this.chartOptions = updatedOptions;
            }


          }
        }
      } catch (error) {
        this.error = error.message;
        console.error('Error fetching device graph:', error);
      } finally {
        this.loading = false;
        this.isTimer = 0
      }



    },

    handleselectedMoistureOption() {
      if (this.isDateRangeChecked) {
        this.isDateRangeChecked = 0;
        this.timer = setInterval(() => {
          this.isTimer = 1
          this.fetchGraphData(this.selectedTimeframe);
        }, 10000);
      }
      this.selectedTimeframe = "1D";
      // Fetch graph data with the updated timeframe
      this.fetchGraphData("1D");
    },
    handleDropdownChange(type) {
      if (!this.isDateRangeChecked) {
 if (type === 'hub') {
      if (this.selectedHub) {
        this.getddReportComponent().then(() => {
          const newController = this.components.find(comp => comp.uuid === this.selectedController);
          if (!newController) {
            this.selectedController = this.components.length > 0 ? this.components[0].uuid : '';
          }

          if (this.selectedController) {
            return this.getddReportDevices();
          } else {
            this.devices = [];
          }
        }).then(() => {
          const newDevice = this.devices.find(device => device.uuid === this.selectedDevice);
          if (!newDevice) {
            this.selectedDevice = '';
          }
          this.fetchGraphData(this.selectedTimeframe);
        }).catch(error => {
          this.error = error.message;
        });
      }
    } else if (type === 'controller') {
      if (this.selectedController) {
        this.getddReportDevices().then(() => {
          const newDevice = this.devices.find(device => device.uuid === this.selectedDevice);
          if (!newDevice) {
            this.selectedDevice = '';
          }
          this.fetchGraphData(this.selectedTimeframe);
        }).catch(error => {
          this.error = error.message;
        });
      }
    } else if (type === 'device') {
      this.fetchGraphData(this.selectedTimeframe); 
    } else if (type === 'moisture') {
      this.fetchGraphData(this.selectedTimeframe); 
    }
      } else if (this.isDateRangeChecked) {
         if (type === 'hub') {
      if (this.selectedHub) {
        this.getddReportComponent().then(() => {
          const newController = this.components.find(comp => comp.uuid === this.selectedController);
          if (!newController) {
            this.selectedController = this.components.length > 0 ? this.components[0].uuid : '';
          }

          if (this.selectedController) {
            return this.getddReportDevices();
          } else {
            this.devices = [];
          }
        }).then(() => {
          const newDevice = this.devices.find(device => device.uuid === this.selectedDevice);
          if (!newDevice) {
            this.selectedDevice = '';
          }
        }).catch(error => {
          this.error = error.message;
        });
      }
    } else if (type === 'controller') {
      if (this.selectedController) {
        this.getddReportDevices().then(() => {
          const newDevice = this.devices.find(device => device.uuid === this.selectedDevice);
          if (!newDevice) {
            this.selectedDevice = '';
          }
        }).catch(error => {
          this.error = error.message;
        });
      }
    } else if (type === 'device') {
    }

      }

    },
    handle1DClick() {
      this.selectedTimeframe = "1D";
      this.fetchGraphData(this.selectedTimeframe);
    },

    // Method to handle 1M button click
    handle1MClick() {
      this.selectedTimeframe = "1M"; // Update the selectedTimeframe
      this.fetchGraphData(this.selectedTimeframe);
    },

    // Method to handle 1Y button click
    handle1YClick() {
      this.selectedTimeframe = "1Y"; // Update the selectedTimeframe
      this.fetchGraphData(this.selectedTimeframe);

    },
    handleDateClick() {
      this.selectedTimeframe = ""; // Update the selectedTimeframe
      this.fetchGraphData(this.selectedTimeframe);

    },
    handleDateRangeChange() {
      if (this.isDateRangeChecked) {
        this.series[0].data = [];
        this.selectedTimeframe = null;
        this.noRecordFound = "";
        this.currentFlowRate = "";
        clearInterval(this.timer);
      } else if (!this.isDateRangeChecked) {
        this.series[0].data = [];
        this.handle1DClick();
        this.timer = setInterval(() => {
          this.isTimer = 1
          this.fetchGraphData(this.selectedTimeframe);
        }, 10000);
      }
    },
    handleDayGraphChange() {
      if(this.isDayGraphChecked || !this.isDayGraphChecked) {
         this.noRecordFound = "";
         this.currentFlowRate = "";
         this.series[0].data = [];
         this.startdate = "";
      }
    },
     validateDate() {
      if (!this.startdate) return;

      const selected = new Date(this.startdate);
      const min = new Date(this.minDate);
      const max = new Date(this.maxDate);

      if (selected < min || selected > max) {
        this.errorMessage = `Select date between ${this.formatDate(this.minDate)} and ${this.formatDate(this.maxDate)}.`;
        this.startdate = '';
      } else {
        this.errorMessage = '';
      }
    },
    formatDate(dateStr) {
  const [year, month, day] = dateStr.split('-');
  return `${day}-${month}-${year}`;
}

    //   updateEndDateMax() {
    //   if (this.startdate) {
    //     const startDateObj = new Date(this.startdate);
    //     startDateObj.setDate(startDateObj.getDate() + 30); // Set the max date to 30 days after start date
    //     this.endDateMax = startDateObj.toISOString().split('T')[0]; // Format to 'YYYY-MM-DD'
    //   }
    //   if (this.enddate) {
    //     const startDate = new Date(this.startdate);
    //     const endDate = new Date(this.enddate);

    //     // Check if the gap between start date and end date is more than 30 days
    //     if ((endDate - startDate) > 30 * 24 * 60 * 60 * 1000) {  // 30 days in milliseconds
    //       this.isDateInvalid = true;
    //       this.enddate = this.startdate; // Reset the end date to the start date if the gap is more than 30 days
    //     } else {
    //       this.isDateInvalid = false; // No error if gap is within 30 days
    //     }
    //   }
    //   // Validate end date and show error message
    //   if (this.enddate && new Date(this.enddate) < new Date(this.startdate)) {
    //     this.isEndDateInvalid = true;
    //     this.enddate = this.startdate; // Optionally reset to start date
    //   } else {
    //     this.isEndDateInvalid = false;
    //   }
    // }

  }


};
</script>
<style scoped></style>
